import React from 'react';
import './About.css'; // Import the CSS file
import {Profile} from '../components/profile';
import {Experience} from '../components/experience';
import {Education} from '../components/education';
import {Certification} from '../components/certification';
import {Skill} from '../components/skill';
import {Link} from '../components/link';
import {Conference} from '../components/conference';
import {OssContribution} from '../components/oss';
import {GlobeComponent} from '../components/GlobeComponent';

import cLogo from '../images/c.svg';
import csharpLogo from '../images/csharp.svg';
import cppLogo from '../images/cpp.svg';
import pythonLogo from '../images/python.svg';
import jupyterLogo from '../images/jupyter.svg';
import goLogo from '../images/go.svg';
import dockerLogo from '../images/docker.svg';
import terraformLogo from '../images/terraform.svg';
import awsLogo from '../images/aws.svg';
import gcpLogo from '../images/gcp.svg';
import javascriptLogo from '../images/javascript.svg';
import typescriptLogo from '../images/typescript.svg';
import reactLogo from '../images/react.svg';
import javaLogo from '../images/java.svg';
import ocamlLogo from '../images/ocaml.svg';
import htmlLogo from '../images/html.svg';
import cssLogo from '../images/css.svg';
import phpLogo from '../images/php.svg';
import laravelLogo from '../images/laravel.svg';
import unityLogo from '../images/unity.svg';
import matlabLogo from '../images/matlab.svg';
import gitLogo from '../images/git.svg';

import atcoderLogo from '../images/atcoder.svg';
import githubLogo from '../images/github.svg';
import qiitaLogo from '../images/qiita.png';
import zennLogo from '../images/zenn.jpg';
import linkedinLogo from '../images/linkedin.png';
import kaggleLogo from '../images/kaggle-icon.svg';

const About = () => {
  const fullExperienceData = [
    {
      date: "April 2025 ~ Present",
      title: "Engineer",
      affiliation: { name: "Preferred Networks Inc.", url: "https://www.preferred.jp/en/"},
      description: "Vision Language Model"
    },
  ];
  const partExperienceData = [
    {
      date: "December 2024 ~ March 2025",
      title: "Project Manager",
      affiliation: { name: "NITI Technology Inc.", url: "https://nititech.jp/" },
      description: "Machine Learning (Vision)"
    },
    {
      date: "December 2024 ~ February 2025",
      title: "AI Engineer",
      affiliation: { name: "IGSA Inc.", url: "https://igsa.co.jp/" },
      description: "Machine Learning (Audio)"
    },
    {
      date: "November 2024 ~ December 2024",
      title: "Frontend Engineer",
      affiliation: { name: "Fybe Inc.", url: "https://www.fybe.jp/" },
      description: "Frontend(NextJS)"
    },
    {
      date: "November 2024 ~ January 2025",
      title: "Software Engineer",
      affiliation: { name: "vaglant Inc.", url: "https://www.vaglant.com/" },
      description: "Frontend(Flutter)"
    },
    {
      date: "October 2024 ~ January 2025",
      title: "Researcher",
      affiliation: { name: "Huawei Inc.", url: "https://www.huawei.com" },
      description: "Machine Learning (Vision)"
    },
    {
      date: "September 2024 ~ January 2025",
      title: "Researcher",
      affiliation: { name: "Future Inc.", url: "https://www.future.co.jp/"},
      description: "Machine Learning (Vision)"
    },
    {
      date: "September 2024 ~ March 2025",
      title: "Engineering Researcher",
      affiliation: { name: "Preferred Networks Inc.", url: "https://www.preferred.jp/en/"},
      description: "Machine Learning (Vision) and Backend(Python, FastAPI)"
    },
    {
      date: "July 2024 ~ September 2024",
      title: "Software Engineer",
      affiliation: { name: "Skewers Inc.", url: "https://skewers.be/"},
      description: "Backend(Go) and Infrastructure(AWS, Terraform)"
    },
    {
      date: "November 2023 ~ June 2024",
      title: "Software Engineer",
      affiliation: { name: "Marubeni Inc.", url: "https://www.marubeni.com/en/"},
      description: "Frontend(TypeScript) and Infrastructure(AWS)"
    },
    {
      date: "August 2023 ~ August 2023",
      title: "Cloud Support Engineer (1 day Internship)",
      affiliation: { name: "Amazon Web Services Inc.", url: "https://aws.amazon.com/jp/"},
      description: "Infrastructure(AWS)"
    },
    {
      date: "August 2023 ~ August 2023",
      title: "Game Engineer (1 week Internship)",
      affiliation: { name: "Cygames Inc.", url: "https://www.cygames.co.jp/"},
      description: "Game Development(C#, Unity)"
    },
    {
      date: "February 2023 ~ September 2024",
      title: "Software Engineer",
      affiliation: { name: "Franky Inc.", url: "https://franky.inc/"},
      description: "Backend(Go) and Infrastructure(AWS, Terraform)"
    },
    {
      date: "February 2023 ~ September 2024",
      title: "Full Stack Engineer",
      affiliation: { name: "Hakky Inc.", url: "https://www.about.st-hakky.com/"},
      description: "Machine Learning(Vision and Language), Data Analysis, Backend(Python), Infrastructure(GCP, Terraform)"
    },
    {
      date: "November 2022 ~ March 2024",
      title: "Software Engineer",
      affiliation: { name: "Bank of Innovation Inc.", url: "https://boi.jp/"},
      description: "Backend(C#, ASP.NET), Frontend(ReactNative) and Infrastructure(AWS)"
    },
    {
      date: "November 2021 ~ February 2022",
      title: "Software Engineer",
      affiliation: { name: "NextBeat Inc.", url: "https://www.nextbeat.co.jp/"},
      description: "Backend(Scala) and Frontend(TypeScript)"
    },
    {
      date: "November 2021 ~ January 2022",
      title: "Software Engineer",
      affiliation: { name: "Massdriver Inc.", url: "https://massdriver.net/"},
      description: "Backend(PHP, Laravel)"
    },
    {
      date: "March 2021 ~ March 2023",
      title: "AI Engineer",
      affiliation: { name: "Ghelia Inc.", url: "https://ghelia.com/"},
      description: "Machine Learning(Vision) and Mathematical Optimization"
    }
  ];

  const educationData = [
    {
      date: "April 2023 ~ March 2025",
      title: "Master of Computer Science",
      affiliation: { name: "Waseda University", url: "https://www.waseda.jp/top/en/"},
      description: "Tokyo, Japan",
    },
    {
      date: "April 2019 ~ March 2023",
      title: "Bachelor of Computer Science",
      affiliation: { name: "Waseda University", url: "https://www.waseda.jp/top/en/"},
      description: "Tokyo, Japan",
    }
  ];

  const certificationData = [
    {
      date: "June 2026",
      title: "TOEFL iBT 90",
      description: "TOEFL iBT Test",
    },
    {
      date: "August 2025",
      title: "TOEIC 915",
      description: "TOEIC Listening & Reading Test, Japan",
    },
    {
      date: "October 2023",
      title: "TOEIC 845",
      description: "TOEIC Listening & Reading Test, Japan",
    },
    {
      date: "October 2021",
      title: "Applied Information Technology Engineer Examination",
      description: "応用情報技術者試験、Japan",
    }
  ];

  const skillData = [
    {
      name: "Python",
      logo: pythonLogo,
      stars: 5,
    },
    {
      name: "Go",
      logo: goLogo,
      stars: 5,
    },
    {
      name: "C",
      logo: cLogo,
      stars: 3,
    },
    {
      name: "C#",
      logo: csharpLogo,
      stars: 4,
    },
    {
      name: "C++",
      logo: cppLogo,
      stars: 5,
    },
    {
      name: "Java",
      logo: javaLogo,
      stars: 3,
    },
    {
      name: "JavaScript",
      logo: javascriptLogo,
      stars: 4,
    },
    {
      name: "TypeScript",
      logo: typescriptLogo,
      stars: 4,
    },
    {
      name: "React",
      logo: reactLogo,
      stars: 4,
    },
    {
      name: "HTML5",
      logo: htmlLogo,
      stars: 4,
    },
    {
      name: "CSS3",
      logo: cssLogo,
      stars: 4,
    },
    {
      name: "PHP",
      logo: phpLogo,
      stars: 3,
    },
    {
      name: "Laravel",
      logo: laravelLogo,
      stars: 3,
    },
    {
      name: "Jupyter",
      logo: jupyterLogo,
      stars: 4,
    },
    {
      name: "Docker",
      logo: dockerLogo,
      stars: 4,
    },
    {
      name: "Terraform",
      logo: terraformLogo,
      stars: 4,
    },
    {
      name: "AWS",
      logo: awsLogo,
      stars: 5,
    },
    {
      name: "Google Cloud",
      logo: gcpLogo,
      stars: 3,
    },
    {
      name: "Ocaml",
      logo: ocamlLogo,
      stars: 1,
    },
    {
      name: "Unity",
      logo: unityLogo,
      stars: 3,
    },
    {
      name: "Matlab",
      logo: matlabLogo,
      stars: 2,
    },
    {
      name: "Git",
      logo: gitLogo,
      stars: 5,
    },
  ];

  const linkData = [
    {
      logo: githubLogo,
      link: "https://github.com/msdsm",
    },
    {
      logo: atcoderLogo,
      link: "https://atcoder.jp/users/MSD_",
    },
    {
      logo: kaggleLogo,
      link: "https://www.kaggle.com/msd0110",
    },
    {
      logo: qiitaLogo,
      link: "https://qiita.com/msdsm",
    },
    {
      logo: zennLogo,
      link: "https://zenn.dev/msdsm",
    },
    {
      logo: linkedinLogo,
      link: "https://www.linkedin.com/in/yuya-masuda-3368a7350/",
    },
  ];

  const conferenceData = [
    {
      year: 2025,
      title: "Enhanced Super-Resolution Using Cross Attention: Refining HMA for Local Image Restoration",
      description: "Accepted to ICAIIC, 1st author",
    },
    {
      year: 2025,
      title: "Efficient Video Super-Resolution via Two-Step 2D SR and Image-to-Image Conditional Generation",
      description: "Accepted to ICAIIC, co-author",
    },
    {
      year: 2024,
      title: "Partial Super Resolution",
      description: "Accepted to ICCE, 1st author",
    },
  ];

  const ossContributionData = [
    {
      repository: "huggingface/diffusers",
      prUrl: "https://github.com/huggingface/diffusers/pull/12841",
      title: "fix the warning torch_dtype is deprecated",
      date: "January 2026"
    },
    {
      repository: "optuna/optuna",
      prUrl: "https://github.com/optuna/optuna/pull/6110",
      title: "Add n_recent_trials to plot_timeline",
      date: "May 2025" 
    },
    {
      repository: "optuna/optuna-dashboard",
      prUrl: "https://github.com/optuna/optuna-dashboard/pull/1077",
      title: "Fix deprecation warning by replacing JournalFileStorage with JournalFileBackend",
      date: "May 2025"
    }
  ]

  const visitedCountries = [
    'JP',  // 日本
    'PH',  // フィリピン
    'VN',  // ベトナム
    'IT',  // イタリア
    'CN-TW',  // 台湾
    'AE',  // UAE
    'ID',  // インドネシア
    'TR',  // トルコ
    'GR',  // ギリシャ
    'FRA', 'FR',  // フランス
    'ES',  // スペイン
    'GB',  // イギリス
    'BE',  // ベルギー
    'DE',  // ドイツ
    'NL',  // オランダ
    'US',   // アメリカ
    'CN',  // 中国
    'HK',  // 香港
    'MO',  // マカオ
    'CA', //　カナダ
    'SG', // シンガポール
    'MY', // マレーシア
    'TH', // タイ
  ];

  return (
    <section id="about">
      <Profile name="Yuya Masuda" email="y.msd0110@gmail.com"/>
      <h3>Links</h3>
      <Link links={linkData}/>
      <h3>Skills</h3>
      <Skill skills={skillData}/>
      <h3>Education</h3>
      <Education educations={educationData}/>
      <h3>Full-time Experience</h3>
      <Experience experiences={fullExperienceData}/>
      <h3>Part-time Experience</h3>
      <Experience experiences={partExperienceData}/>
      <h3>Certifications</h3>
      <Certification certifications={certificationData}/>
      <h3>International Conferences</h3>
      <Conference conferences={conferenceData}/>
      <h3>OSS Contributions</h3>
      <OssContribution contributions={ossContributionData}/>
      <h3>visited countries</h3>
      <GlobeComponent highlightedCountries={visitedCountries} />
    </section>
  );
};

export default About;
